import React, { useEffect } from "react";
import { ImgController } from "../Scripts/ImgController";
import assets from "../../assets/assets";
import { useNavigate } from "react-router-dom";
import Ripples from "react-ripples";
const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    document.title = "MMusic - Олдсонгүй :(";
  }, []);
  return (
    <div className="w-full h-screen">
      <div className="flex flex-col justify-center items-center w-full h-full">
        <ImgController src={assets.image.notFound404} />

        <div className="text-center pb-6">
          <h4 className="font-bold text-5xl pb-2.5">Хуудас олдсонгүй</h4>
          <h5>
            Уучлаарай, Таны орох гэж оролдсон хуудас олдсонгүй. <br />
            Хэрэв танд тусламж хэрэгтэй бол манай хэрэглэгчийн төврүү хандана уу
          </h5>
        </div>
        <div className="confirm-button">
          <Ripples color="#FFFFFF40" during={600} className="rounded-2xl">
            <div
              className="flex flex-row justify-center items-center w-full h-full"
              onClick={() => {
                navigate("/");
              }}
            >
              <h5 className="px-4 py-2 font-semibold">Нүүр хуудасруу буцах</h5>
            </div>
          </Ripples>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
